import { useEffect, useState } from "react";
import api from "@/lib/api";

// Customer-facing plan info comes ONLY from GET /api/billing/plan (display only).
export const PRO_BENEFITS = [
  "Live conversations with Fluent Friend",
  "FluentLens",
  "Voice Journal",
  "Intelligent Today",
  "Vocabulary & spaced repetition",
  "Personal Language Brain",
  "All supported languages",
];
export const PRO_TAGLINE = "Your life becomes your language course.";

let cached = null;
let pending = null;
const load = () => (pending ||= api.get("/billing/plan").then((r) => (cached = r.data)).catch(() => { pending = null; return null; }));

export function formatPrice(plan) {
  if (!plan) return "";
  return new Intl.NumberFormat("en-US", { style: "currency", currency: plan.currency.toUpperCase() }).format(plan.price);
}

export function usePlan() {
  const [plan, setPlan] = useState(cached);
  useEffect(() => { if (!cached) load().then((p) => p && setPlan(p)); }, []);
  return plan;
}

export function PlanPrice({ plan, className = "", unitClass = "text-lg", unit }) {
  if (!plan) return <span className={className} data-testid="plan-price">…</span>;
  return <span className={className} data-testid="plan-price">{formatPrice(plan)}<span className={unitClass}>/{unit ?? (plan.interval === "month" ? "month" : plan.interval)}</span></span>;
}
